import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { CalendarDays, Ticket, GraduationCap, Trophy, Settings, Users } from "lucide-react";
import { motion } from "framer-motion";
import AdminCalendar from "@/components/admin/AdminCalendar";
import AdminBookings from "@/components/admin/AdminBookings";
import AdminCoaching from "@/components/admin/AdminCoaching";
import AdminCoaches from "@/components/admin/AdminCoaches";
import AdminTournaments from "@/components/admin/AdminTournaments";
import AdminCourtSettings from "@/components/admin/AdminCourtSettings";
import AdminUsers from "@/components/admin/AdminUsers";
import AdminAlerts from "@/components/admin/AdminAlerts";
import { useLanguage } from "@/contexts/LanguageContext";


const TABS = [
  { v: "calendar", icon: CalendarDays }, { v: "bookings", icon: Ticket }, { v: "lessons", icon: GraduationCap },
  { v: "tournaments", icon: Trophy }, { v: "club", icon: Settings }, { v: "members", icon: Users },
];

export default function Admin() {
  const { t } = useLanguage();
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-8 sm:py-12" data-testid="admin-page">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
        <h1 className="font-heading font-black text-3xl sm:text-4xl tracking-tight mb-6">{t("admin.title")}</h1>

        <AdminAlerts />

        <Tabs defaultValue="calendar">
          <TabsList className="h-auto flex-wrap justify-start gap-2 bg-transparent p-0 mb-6">
            {TABS.map(tab => (
              <TabsTrigger key={tab.v} value={tab.v} data-testid={`admin-tab-${tab.v}`}
                className="rounded-2xl border border-border/50 bg-card px-5 py-3 text-base font-semibold gap-2 data-[state=active]:bg-coral data-[state=active]:text-white data-[state=active]:border-coral">
                <tab.icon size={18} /> {t(`admin.tab_${tab.v}`)}
              </TabsTrigger>
            ))}
          </TabsList>

          {TABS.map(tab => (
            <TabsContent key={tab.v} value={tab.v} className="space-y-4">
              <p className="text-sm text-muted-foreground" data-testid={`admin-help-${tab.v}`}>{t(`admin.help_${tab.v}`)}</p>
              {tab.v === "calendar" && <AdminCalendar />}
              {tab.v === "bookings" && <AdminBookings />}
              {tab.v === "lessons" && <><AdminCoaching /><AdminCoaches /></>}
              {tab.v === "tournaments" && <AdminTournaments />}
              {tab.v === "club" && <AdminCourtSettings />}
              {tab.v === "members" && <AdminUsers />}
            </TabsContent>
          ))}
        </Tabs>
      </motion.div>
    </div>
  );
}
